export const ASSESSMENT_PAGE_STRING_FIELD_NAMES = [
  'initial_assessment_date',
  'reassessment_date',
  'parent_interview_summary',
  'assessment_results',
  'priorities',
  'telehealth_assessment_date',
  'observations',
] as const;

export const ASSESSMENT_PAGE_BOOLEAN_FIELD_NAMES = [
  'diagnostic_report_reviewed',
  'no_maladaptive_behavior',
  'telehealth_readiness_assessment_needed',
] as const;

export const ASSESSMENT_PAGE_STRING_ARRAY_FIELD_NAMES = [
  'additional_files_viewed',
  'barriers',
] as const;

export const ASSESSMENT_PAGE_FIELD_NAMES = [
  ...ASSESSMENT_PAGE_STRING_FIELD_NAMES,
  ...ASSESSMENT_PAGE_BOOLEAN_FIELD_NAMES,
  ...ASSESSMENT_PAGE_STRING_ARRAY_FIELD_NAMES,
] as const;

export const ASSESSMENT_CAREGIVER_READINESS_ITEMS = [
  'attends_to_screen',
  'follows_instructions',
  'caregiver_mediation',
  'no_severe_behavior',
  'communicates_needs',
  'reinforcers_available',
] as const;

export const ASSESSMENT_CHILD_READINESS_ITEMS = [
  'available_during_sessions',
  'implements_directions',
  'operates_tech',
  'manages_safety',
  'distraction_free_area',
  'reinforcers_ready',
  'attends_reliably',
] as const;

export const ASSESSMENT_ENVIRONMENT_READINESS_ITEMS = [
  'stable_internet',
  'camera_audio',
  'quiet_environment',
  'lighting',
  'materials',
  'confidential_space',
] as const;

export const ASSESSMENT_READINESS_ITEMS = [
  ...ASSESSMENT_CAREGIVER_READINESS_ITEMS,
  ...ASSESSMENT_CHILD_READINESS_ITEMS,
  ...ASSESSMENT_ENVIRONMENT_READINESS_ITEMS,
] as const;

export const ASSESSMENT_READINESS_VALUES = {
  NOT_READY: 'Not ready',
  SOMEWHAT: 'Somewhat',
  READY: 'Ready',
} as const;
